import { observer } from "mobx-react";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../lib";
import { authStore, resultStore } from "../stores";
import Logo from "./Logo";
import "./TopBar.scss";

const TopBar = () => {
  return (
    <div className="TopBar">
      <div className="TopBar_wrapper">
        <div className="TopBar_brand">
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <div className="TopBar_action">
          {authStore.authenticating ? null : !authStore.auth ? (
            <p>
              {resultStore.responses ? (
                <Button styleType="blank" to="/results">
                  Your Results
                </Button>
              ) : null}
              <Button to="/signin">Sign In</Button>
            </p>
          ) : (
            <p>
              Hi, <strong>{authStore.auth.email}</strong>{" "}
              {resultStore.responses ? (
                <Button
                  styleType="blank"
                  to={resultStore.churchResponse ? "/dashboard" : "/results"}
                >
                  Your Results
                </Button>
              ) : null}
              <Button styleType="blank" onClick={authStore.signOut}>
                Sign Out
              </Button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

TopBar.displayName = "TopBar";

export default observer(TopBar);



// WEBPACK FOOTER //
// ./src/lib/TopBar.js